
export const getOneDriveIdentityInfoBarLoadingPageStyles = (): React.CSSProperties =>  {
    const onedriveInfoBarStyle: React.CSSProperties = {
      position: 'relative',
      bottom: 0,
    }
    return onedriveInfoBarStyle;
}